import React from 'react';
import { Tooltip } from 'primereact/tooltip';
import { Button } from 'primereact/button';

import { useFileManagerContext } from 'modules/FileManagerV2/context/FileManagerContext';

function CreateDocument() {
  const { modals } = useFileManagerContext();

  const handleCreateDocument = () => {
    modals.setShowCreateDocumentModal(true);
  };

  return (
    <Button className="files-sq-button create-document pointer grid-view-style" onClick={handleCreateDocument}>
      <Tooltip content="Create Document" position="top" target=".create-document" showDelay={500} />
      <i className="icon-doc fa-lg"></i>
    </Button>
  );
}

export default CreateDocument;
